import React, { useContext, useState } from 'react'
import { FormBuilder } from '@tf/formbuilder'
import { useTranslation } from 'react-i18next'
import SspContext from '../../../contexts/SspContext'
import {
	ICardEnrollment,
	ICreditBalance,
} from '../../../interfaces/i-api-creaditCard'
import setPasswordIdCheckService from '../../../services/CreditCardServices/setPasswordIdCheckService'
import {
	CustomerForm,
	getErrorWithFullMessage,
	getMarket,
	getLanguageLocale,
} from 'shared'
import { FormFactory } from '../../../../shared/formBuilder/formFactory'
import { Heading } from '../../../components/index'

const SetPasswordIdCheck = () => {
	const { t } = useTranslation()

	const { customerData, overviewData, success, setSuccess } =
		useContext(SspContext)
	const [error, setError] = useState<Error>()
	const [loading, setLoading] = useState(false)
	const creditCardData = overviewData as ICreditBalance

	const formSchema = FormFactory(
		CustomerForm.SetPasswordIdCheckForm,
		{
			formName: 'Password',
			blockName: 'Password',
			market: getMarket(),
			locale: getLanguageLocale(),
			getDataUrl: '',
			validationErrorList: false,
			requiredMessage: t('ValidateRequired'),
			submitButtonText: t('Save'),
		},
		customerData,
	)

	function checkPassword(info: any) {
		let reg =
			/^(?=.*[a-z])(?=.*[A-Z])(?=(.*\d){2})(?=.*[-@#$&*+!?])[A-Za-z\d\-@#$&*+!?]{8,}$/

		if (reg.test(info.password)) {
			if (info.password === info.repeatPassword) {
				setError(undefined)
				return true
			} else {
				setError(new Error(t('PasswordsMatch')))
				return false
			}
		}
		setError(new Error(t('PasswordValidation')))
		return false
	}

	const submit = async (info: any) => {
		if (!checkPassword(info)) return

		let cardEnrollment: ICardEnrollment
		if (customerData) {
			cardEnrollment = {
				customerId: customerData.customerId,
				cardAgreementId: parseInt(creditCardData.cardAgreementId),
				cardHolderId: '',
				label: 'TF_POTP',
				password: info.password,
				phoneNo: customerData.mobilePhoneNumber.replaceAll(' ', ''),
				status: '',
			}
		}

		try {
			setLoading(true)
			await setPasswordIdCheckService(cardEnrollment!, t)
			setSuccess({ ...success, setPassword: true })
			setLoading(false)
		} catch (e: any) {
			setLoading(false)
			setError(getErrorWithFullMessage(e))
		}
	}

	return (
		<div className="fade-in set-password container d-flex justify-content-center">
			<div className="fixed-width my-5">
				{loading && <div id="circle-spinner"></div>}
				{success.setPassword && (
					<Heading
						title="SetPasswordSuccess"
						description="SetPasswordSuccessDescription"
					/>
				)}
				{!success.setPassword && !loading && (
					<>
						<Heading
							title="SetPasswordTitle"
							description="SetPasswordDescription"
						/>
						<FormBuilder
							formSchema={formSchema!}
							apiError={undefined}
							showErrorsInForm={true}
							showSubmitButton={true}
							onSubmit={(values) => submit(values)}
						/>
					</>
				)}
				{error && !loading && !success.setPassword && (
					<div className="error-msg">{error.message}</div>
				)}
			</div>
		</div>
	)
}
export default SetPasswordIdCheck
